(function () {
    'use strict';
    app.controller('usermanualcontroller', ['$scope', 'progressBarService', '$location', '$cookies', '$rootScope', '$timeout', function ($scope, progressBarService, $location, $cookies, $rootScope, $timeout) {

        //if ($rootScope.globalConfig.adminUser == undefined || $rootScope.globalConfig.adminUser != $cookies.get("userName")) {
        //    $location.path("/notfound");
        //    return false;
        //}
        $scope.isAuthenticated = getLocalValue("isAuthenticated");


    }]);
})();